<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.Td" label="Td"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.D" label="D"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.H" label="H"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 240 97.25"
         style="height: 150px"
    >
        <defs>
            <style>.tddhte1{fill:#eaf4fb;}.tddhte2{fill:#1d1d1b;}.tddhte3,.tddhte4{fill:none;stroke:#0090c9;}.tddhte3{stroke-width:1.5px;}.tddhte4{stroke-width:3px;}.tddhte5{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_TdDHTE_schema</title>
        <rect class="tddhte1"
              y="1.25"
              width="240"
              height="48" />
        <path class="tddhte2"
              d="M64.77,15.91h5.85c2.71,0,5.91,0,8.15,2.64a11.63,11.63,0,0,1,2.49,7.64c0,4.37-1.82,7.06-3.36,8.29-2,1.65-4.48,1.65-7.45,1.65H64.77Zm2.8,17.92h2.74c1.93,0,4-.11,5.29-1.12,2.58-1.93,2.66-5.23,2.66-6.41,0-.75-.05-4.2-2-6.3-1.29-1.43-2.91-1.76-5.37-1.76H67.57Z"
              transform="translate(0 -0.75)" />
        <path class="tddhte2"
              d="M167,36.13V18.29h-6.78V15.91h16.32v2.38h-6.77V36.13Z"
              transform="translate(0 -0.75)" />
        <path class="tddhte2"
              d="M209.89,15.91h12.68v2.38h-9.88v6.3h9.41V27h-9.41v6.72H222.8v2.46H209.89Z"
              transform="translate(0 -0.75)" />
        <path class="tddhte2"
              d="M14,36.13V18.29H7.17V15.91H23.5v2.38H16.72V36.13Z"
              transform="translate(0 -0.75)" />
        <path class="tddhte2"
              d="M36.15,15.94h2.63v18c0,.31.06,1.51.12,2.24H36.26l0-2.24A4.13,4.13,0,0,1,35,35.37a6.35,6.35,0,0,1-3.48,1c-1.87,0-6-1-6-7.14,0-5.35,3.05-7.67,6.35-7.67A4.53,4.53,0,0,1,36.15,24Zm-1,9a3.81,3.81,0,0,0-3.08-1.43c-3.86,0-3.86,4.67-3.86,5.63,0,2.49.64,5.37,3.86,5.37,4.14,0,4.14-4.56,4.14-5.65A6,6,0,0,0,35.17,25Z"
              transform="translate(0 -0.75)" />
        <path class="tddhte2"
              d="M114.72,15.91v8.68h9.6V15.91h2.8V36.13h-2.8V27h-9.6v9.13h-2.8V15.91Z"
              transform="translate(0 -0.75)" />
        <line class="tddhte3"
              x1="47.75"
              y1="1.25"
              x2="47.75"
              y2="97.25" />
        <line class="tddhte3"
              x1="143.49"
              y1="1.25"
              x2="143.49"
              y2="97.25" />
        <line class="tddhte3"
              x1="191.66"
              y1="1.25"
              x2="191.66"
              y2="97.25" />
        <line class="tddhte4"
              x1="95.75"
              y1="1.25"
              x2="95.75"
              y2="97.25" />
        <line class="tddhte3"
              y1="49.75"
              x2="240"
              y2="49.75" />
        <line class="tddhte3"
              y1="0.75"
              x2="240"
              y2="0.75" />
        <text class="tddhte5"
              transform="translate(208.22 84.77)">{{rangeModel.E}}</text>
        <text class="tddhte5"
              transform="translate(160.22 84.77)">{{rangeModel.T}}</text>
        <text class="tddhte5"
              transform="translate(112.22 84.77)">{{rangeModel.H}}</text>
        <text class="tddhte5"
              transform="translate(64.22 84.77)">{{rangeModel.D}}</text>
        <text class="tddhte5"
              transform="translate(16.22 84.77)">{{rangeModel.Td}}</text>
    </svg>
</ng-template>

